export default {
  methods: {
    s3StaticUrl(filePath: string): string {
      const base = (window as any).__proffSpa__?.s3BasePath || '';
      return `${base}/static/${filePath}`;
    },
  },
};
